"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinnerTheme = void 0;
var colors_1 = require("./colors");
exports.spinnerTheme = {
    color: colors_1.colors.primary.primaryBlue,
    size: '3rem',
};
